import { useState } from "react";
import { useTranslation } from 'react-i18next';

import styles from "./index.module.css";

export function InactivitySection({ data, form, setForm, setSaveIsDisabled }) {
  const { t } = useTranslation();
  const [error, setError] = useState("");

  const handleCheckboxChange = (event) => {
    setForm({
      ...form,
      check_inactive_ports: event.target.checked,
    });
  };

  const handleInputChange = (event) => {
    const value = event.target.value;

    if (value === "") {
      setError(t('inactivity.errorEmpty'));
      setSaveIsDisabled(true);
      setForm({
        ...form,
        elapsed_time_to_check_inactive_ports: undefined,
      });
    } else if (value >= 0) {
      setError("");
      setSaveIsDisabled(false);
      setForm({
        ...form,
        elapsed_time_to_check_inactive_ports: parseInt(event.target.value),
      });
    } else {
      setError(t('inactivity.errorNegative'));
      setSaveIsDisabled(true);
    }
  };

  return (
    <div className="mt-4 mx-5 d-flex justify-center align-items-center flex-column">
      <div
        className={`d-flex justify-center align-items-center ${styles["custom-container"]}`}
      >
        <div className="label text-black">{t('inactivity.activate')}</div>
        <input
          type="checkbox"
          checked={form.check_inactive_ports}
          onChange={handleCheckboxChange}
        />
      </div>
      <div
        className={`d-flex justify-center align-items-center ${styles["custom-container"]}`}
      >
        <div className="label text-black">{t('inactivity.seconds')}</div>
        <input
          type="number"
          value={form.elapsed_time_to_check_inactive_ports}
          onChange={handleInputChange}
          className={`${styles["small-custom-name-input"]}`}
        />
      </div>
      {error && <div className={styles["error-message"]}>{error}</div>}
    </div>
  );
}

